import { API } from '@shared/types/api';
import { MBReactionButtonWithPicker } from '../components/reaction/buttonWithPicker';
import { useSelectedReactions, useToggleReaction } from './hooks';

type OwnProps = Omit<
  MBReactionButtonWithPicker['props'],
  'onToggleReaction' | 'selected' | 'anchorName'
> & {
  message: API.ChatMessageFragment;
  channelSlug: string;
  anchorName: string;
};

export function MBMessageReactionButton({ message, channelSlug, anchorName }: OwnProps) {
  const selected = useSelectedReactions(message);
  const toggleReaction = useToggleReaction(message, channelSlug);
  return (
    <MBReactionButtonWithPicker
      anchorName={anchorName}
      selected={selected}
      onToggleReaction={toggleReaction}
      testID="chat-message-reaction-button"
    />
  );
}
